import ApplicationController from './application_controller.js'

import css from './tooltips.module.scss'

export default class TooltipController extends ApplicationController {

  connect() {
    var elems = this.element.querySelectorAll("[title]")
    elems.forEach(element => {
      element.dataset.tooltipContent = element.getAttribute('title')
      element.removeAttribute('title')

      var tip_el = document.createElement("span")
      tip_el.classList.add("tooltip_elem")
      tip_el.classList.add(css.tooltip)
      tip_el.style.display = "none"
      tip_el.style.zIndex = 1000
      tip_el.style.position = "absolute"
      element.appendChild(tip_el)

      element.addEventListener('mouseover', (e) => {
        var tip = e.target.querySelector(".tooltip_elem")
        if (tip) {
          tip.innerHTML = e.target.dataset.tooltipContent
          tip.style.display = "block"
          var target_rect = e.target.getBoundingClientRect()
          var parent_rect = e.target.getBoundingClientRect()
          var left = target_rect.right - (target_rect.width / 2) - (tip.scrollWidth / 2)
          var top = window.scrollY + parent_rect.y - tip.scrollHeight - 10
          tip.style.left = `${left}px`
          tip.style.top = `${top}px`
        }
      })
      element.addEventListener('mouseout', (e) => {
        var tip = e.target.querySelector(".tooltip_elem")
        if (tip) {
          tip.style.display = "none"
        }
      })
    })
  }

}